import { createStore } from 'vuex'
import { networkInformation } from "@/store/networkInformation";
import ApiQueue from "@/libraries/ApiQueue";
import { users } from "@/store/users";
import { timer } from "@/store/timer";
import { shifts } from "@/store/shifts";

export default createStore({
  modules: {
    networkInformation,
    users,
    timer,
    shifts
  },
  actions: {
    init({dispatch}) {
      ApiQueue.restore();
      dispatch('users/restore');
      dispatch('shifts/restore');
      dispatch('timer/restore');

      ApiQueue.init();
      dispatch('users/init');
      dispatch('shifts/init');
      dispatch('timer/init');
    }
  }
});